import * as React from 'react';
var ResizeContext = /*#__PURE__*/React.createContext(null);
export default ResizeContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/ResizeContext.js
// module id = 493
// module chunks = 0